import { 
    CONTRACTOR_SEARCH_SELECT_REGION
} from '../Actions/ContractorSearch.action';

const defaultState = { 
    selectedRegion: null,
}

export const contractorSearch = (state = defaultState, action) => {
    const { type, payload } = action;
    switch (type) {
        case CONTRACTOR_SEARCH_SELECT_REGION:
            return {
                ...state,
                ...payload,
            };
        default:
            return state;
    }
}
